import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Label } from './ui/Label';
import { Card } from './ui/Card';
import { LayoutGrid, Lock, Mail, ArrowRight } from 'lucide-react';
interface LoginPageProps {
  onLogin: (email: string) => void;
}
export function LoginPage({
  onLogin
}: LoginPageProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    // Mock authentication - accept any credentials
    setTimeout(() => {
      onLogin(email || 'demo@firma.de');
    }, 600);
  };
  return <div className="min-h-screen w-full bg-muted/20 flex items-center justify-center p-4" data-id="element-223">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-muted/20 -z-10" data-id="element-224" />

      <Card className="w-full max-w-md overflow-hidden border-none shadow-2xl" data-id="element-225">
        <div className="bg-primary/5 p-8 text-center border-b border-border/50" data-id="element-226">
          <div className="mx-auto h-16 w-16 rounded-2xl bg-gradient-to-br from-primary to-primary/80 text-primary-foreground shadow-lg shadow-primary/20 flex items-center justify-center mb-6" data-id="element-227">
            <img src="https://cdn.magicpatterns.com/uploads/kd4roRxqwsaiLMQsYfWTFP/AZxTKdL0M29kQl9SQ-fUpQ-AZxTKdL1zoLvzFyzOkPHjA.jpg" alt="Logo" className="h-16 w-16 object-cover rounded-2xl" data-id="element-228" />
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-foreground" data-id="element-229">
            RessourcenPlaner
          </h1>
          <p className="text-sm text-muted-foreground font-medium mt-1" data-id="element-230">
            Maschinenbau GmbH
          </p>
        </div>

        <div className="p-8" data-id="element-231">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-232">
            <div className="space-y-2" data-id="element-233">
              <Label htmlFor="email" data-id="element-234">E-Mail-Adresse</Label>
              <div className="relative" data-id="element-235">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" data-id="element-236" />
                <input id="email" type="text" placeholder="name@firma.de" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 pl-10 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2" value={email} onChange={e => setEmail(e.target.value)} data-id="element-237" />
              </div>
            </div>

            <div className="space-y-2" data-id="element-238">
              <div className="flex items-center justify-between" data-id="element-239">
                <Label htmlFor="password" data-id="element-240">Passwort</Label>
              </div>
              <div className="relative" data-id="element-241">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" data-id="element-242" />
                <input id="password" type="password" placeholder="••••••••" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 pl-10 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2" value={password} onChange={e => setPassword(e.target.value)} data-id="element-243" />
              </div>
            </div>

            {error && <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md font-medium text-center animate-in fade-in slide-in-from-top-1" data-id="element-244">
                {error}
              </div>}

            <Button type="submit" className="w-full h-11 text-base shadow-lg shadow-primary/20 hover:shadow-primary/30 transition-all" disabled={isLoading} data-id="element-245">
              {isLoading ? <span className="flex items-center gap-2" data-id="element-246">
                  <div className="h-4 w-4 border-2 border-current border-t-transparent rounded-full animate-spin" data-id="element-247" />
                  Anmelden...
                </span> : <span className="flex items-center gap-2" data-id="element-248">
                  Anmelden <ArrowRight className="h-4 w-4" data-id="element-249" />
                </span>}
            </Button>
          </form>

          <div className="mt-8 pt-6 border-t text-center" data-id="element-250">
            <p className="text-xs text-muted-foreground bg-muted/50 py-2 px-4 rounded-full inline-block" data-id="element-251">
              <span className="font-semibold" data-id="element-252">Demo:</span> Beliebige Eingaben
              verwenden
            </p>
          </div>
        </div>
      </Card>
    </div>;
}